import React from "react";
import TabSlider from "../../common/TabSlider";
import { SlotTabData } from "../../helper/Helper";
import { SportsBookIcon } from "../../helper/Icon2";
import SwiperSlider from "../../common/SwiperSlider";

function SportsbookTabContent() {
  return (
    <>
      <SwiperSlider
        sectionHeading={"Sports Book"}
        icon={<SportsBookIcon />}
        data={SlotTabData}
      />
    </>
  );
}

export default SportsbookTabContent;
